import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavSwitchIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M10.7529 5.25L10.753 14.75C10.753 15.7165 11.5395 16.5 12.5098 16.5C13.4801 16.5 14.2667 15.7165 14.2667 14.75L14.2667 10.0605L13.5745 10.75C13.2805 11.0429 12.8038 11.0429 12.5098 10.75C12.2158 10.4571 12.2158 9.98232 12.5098 9.68945L14.6647 7.54301C14.8607 7.34775 15.1786 7.34774 15.3746 7.54301L17.5295 9.68945C17.8235 9.98232 17.8235 10.4571 17.5295 10.75C17.2355 11.0429 16.7588 11.0429 16.4648 10.75L15.7726 10.0605L15.7726 14.75C15.7726 16.5449 14.3118 18 12.5098 18C10.7078 18 9.24705 16.5449 9.24705 14.75L9.24705 5.25C9.24705 4.2835 8.46047 3.5 7.49017 3.5C6.51987 3.5 5.73329 4.2835 5.73329 5.25L5.73329 10.4395L6.42545 9.75C6.71947 9.45714 7.19616 9.45714 7.49017 9.75C7.78418 10.0429 7.78418 10.5177 7.49017 10.8105L5.33529 12.957C5.13926 13.1523 4.82143 13.1523 4.6254 12.957L2.47051 10.8105C2.1765 10.5177 2.1765 10.0429 2.47051 9.75C2.76452 9.45714 3.24121 9.45714 3.53523 9.75L4.22739 10.4395L4.22739 5.25C4.22739 3.45508 5.68819 2 7.49017 2C9.29215 2 10.7529 3.45507 10.7529 5.25Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
